import React from 'react';
import {
  Switch,
  Route
} from "react-router-dom";

import NavBar from "./component/navBar.jsx";
import Home from "./component/home.jsx";
import Footer from "./component/footer.jsx";

const App = () => {
  
  return (
    <div id="app">
      <Switch>
          <Route path="/" exact>
            <NavBar/>
            <Home/>
          </Route>
      </Switch>
      <Footer />
    </div>
  );
}


export default App;
